import { useRef, useEffect } from 'react';
import { Animated } from 'react-native';

function useTobiScale({ isVisible, dropTray }) {
  const animation = useRef(new Animated.Value(1)).current;

  useEffect(() => {
    const dropDuration = 0;
    const delay = 0;
    const duration = dropTray ? dropDuration : isVisible ? 350 : 150;
    Animated.timing(animation, {
      toValue: isVisible ? 0 : 1,
      duration: duration,
      delay,
      useNativeDriver: false,
    }).start();
  }, [isVisible, animation]);

  const bottom = animation.interpolate({
    inputRange: [0, 0, 1],
    outputRange: [0, 35, 0],
  });

  const scale = animation.interpolate({
    inputRange: [0, 0.5, 1],
    outputRange: [1, 0.5, 1],
  });

  return {
    bottom,
    scale,
  };
}

export default useTobiScale;
